import referral from './referral.vue';
import uniqueReferralPage from './referralHome/referralHome.vue';

const referralRoutes = [
  {
    path: '/referral',
    component: referral,
    children: [
      {
        path: 'user/:id/:ghostuid',
        name: 'useridghost',
        component: uniqueReferralPage,
      },
      {
        path: 'user/:id',
        name: 'userid',
        component: uniqueReferralPage,
      },
      {
        path: 'user',
        name: 'user',
        component: uniqueReferralPage,
      },
      {
        path: '',
        redirect: 'user/',
      },
    ],
  },
];

export default referralRoutes;
